import request from '../request'

export function getList(params) {
  return request({
    url: '/vue-admin-template/table/list',
    method: 'get',
    params
  })
}

export function mockTabelData(params) {
  return request({
    url: '/vue-admin-template/table/data/list',
    method: 'get',
    params
  })
}

export function getArea() {
  return request({
    url: '/master/data/getArea',
    method: 'get'
  })
}

// workflow工作流列表（崔鹏飞）
export function getList_workflow(params) {
  return request({
    url: '/wfc/model/list',
    method: 'get',
    params
  })
}

// 获取modelId（崔鹏飞）
export function getModelId(data) {
  return request({
    url: '/wfc/model/create',
    method: 'post',
    data
  })
}

// 预览xml（崔鹏飞）
export function getXml(id) {
  return request({
    url: '/wfc/model/open-xml/' + id,
    method: 'get'
  })
}

// 预览图片（崔鹏飞）
export function getImg(id) {
  return request({
    url: '/wfc/model/open-img/' + id,
    method: 'get'
  })
}

// 复制modelId（崔鹏飞）
export function copyModelId(data) {
  return request({
    url: '/wfc/model/copy',
    method: 'post',
    data
  })
}

// 删除工作流（崔鹏飞）
export function delModel(data) {
  return request({
    url: '/wfc/model/del',
    method: 'post',
    data
  })
}

// 部署工作流（崔鹏飞）
export function deployModel(data) {
  return request({
    url: '/wfc/model/deploy',
    method: 'post',
    data
  })
}

// 下载xml（崔鹏飞）
export function downloadXml(id) {
  return request({
    url: '/wfc/model/download-xml/' + id,
    method: 'get'
  })
}

// 下载图片（崔鹏飞）
export function downloadImg(id) {
  return request({
    url: '/wfc/model/open-img/' + id,
    method: 'get'
  })
}

// 初始化用户（崔鹏飞）
export function resetUser() {
  return request({
    url: '/wfc/model/reset-user',
    method: 'post'
  })
}

// 获取业务流程表名下拉
// 流程规则
export function getList_select(params) {
  return request({
    url: '/wfc/workflow/enums/' + 1,
    method: 'get',
    params
  })
}

// 流程规则
export function getList_flowRule(params) {
  return request({
    url: '/wfc/flow-def/list',
    method: 'get',
    params
  })
}
// 流程规则处理事项
export function flowDefEnums(flowDefId) {
  return request({
    url: `/wfc/flow-def/enums-item/${flowDefId}`,
    method: 'get'
  })
}
// 条件字段接口
export function flowDefParamList(flowDefId) {
  return request({
    url: `/wfc/flow-def/param-list/${flowDefId}`,
    method: 'get'
  })
}
// 部门
export function departmentOrg() {
  return request({
    url: `/umc/orgs/kj?format=select2`,
    method: 'get'
  })
}
// 员工
export function getUserList() {
  return request({
    url: `/umc/users/kj?format=select2`,
    method: 'get'
  })
}
// 角色
export function getRolesList() {
  return request({
    url: `/umc/roles?format=select2`,
    method: 'get'
  })
}
// 新增 、编辑、 删除
export function deal_flowRule(params, type) {
  return request({
    url: '/wfc/flow-def' + (type !== 'post' ? '/' + params.id : ''),
    method: type,
    data: params
  })
}
// 新增
export function addflowRule(data) {
  return request({
    url: '/wfc/flow-def',
    method: 'post',
    data: data
  })
}
// 编辑
export function editflowRule(data, id) {
  return request({
    url: `/wfc/flow-def/${id}`,
    method: 'put',
    data: data
  })
}
// 删除
export function delflowRule(data) {
  return request({
    url: `/wfc/flow-def/${data.id}`,
    method: 'delete',
    data: data
  })
}
// 启用、禁用
export function resetFlow(id, status) {
  return request({
    url: '/wfc/flow-def/enable-disable/' + id + '/' + status,
    method: 'get'
  })
}
// 详情
export function getFlowDefDetail(params) {
  return request({
    url: `/wfc/flow-def/${params.id}`,
    method: 'get',
    params
  })
}
// 复制
export function getFlowDefRecordList(params) {
  return request({
    url: `/wfc/flow-def/record-list/${params.id}`,
    method: 'get',
    params
  })
}

// 历史部署流程的详情
export function historyDetail(params) {
  return request({
    url: `/wfc/flow-def/record/${params.id}`,
    method: 'get'
  })
}

// 待办
export function getList_deal(params) {
  return request({
    url: '/wfc/flow-info/myAgendaList',
    method: 'get',
    params
  })
}

// 启动流程
export function startFlow(data) {
  return request({
    url: '/wfc/flow-info/startWorkFlow',
    method: 'post',
    data
  })
}
// 重启流程
export function restartFlow(data) {
  return request({
    url: '/wfc/flow-info/aginStartWorkFlow',
    method: 'post',
    data
  })
}

// 获取转办人列表
export function getPeopleList(params) {
  return request({
    url: '/wfc/flow-info/getTurnUserList',
    method: 'get',
    params
  })
}

// 获取审批流程
export function approveFlow(data) {
  return request({
    url: '/wfc/flow-info/auditWorkFlow',
    method: 'post',
    data
  })
}

// 撤销审批流程
export function revokeFlow(data) {
  return request({
    url: '/wfc/flow-info/cancelWorkFlow',
    method: 'post',
    data
  })
}

// 查询审批记录
export function getList_approve(flowId) {
  return request({
    url: '/wfc/flow-info/getFlowLogList/' + flowId,
    method: 'get'
  })
}

// 预览审批流程图片（崔鹏飞）
export function getImg_flow(id) {
  return request({
    url: '/wfc/flow-info/queryByflowIdToImg/' + id,
    method: 'get'
  })
}
